import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosFloatingActionButtonComponent } from './pos-floating-action-button.component';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';



@NgModule({
  declarations: [PosFloatingActionButtonComponent],
  imports: [
    CommonModule
  ],
  providers: [PosFloatingActionButtonService],
  exports: [PosFloatingActionButtonComponent]
})
export class PosFloatingActionButtonModule { }
